import React from "react";
import { brand } from "../mock";
import { GraduationCap, Trophy, Building2 } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-28 relative">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="text-xs tracking-[0.32em] text-emerald-400 uppercase mb-4">03 — About</div>
          <h2 className="gt-serif text-4xl md:text-5xl leading-tight">
            An operator who has lived every slide he teaches.
          </h2>

          <div className="mt-10 space-y-4">
            <Row icon={GraduationCap} label="Education" value="IIM Kozhikode · B.E. Computer Science" />
            <Row icon={Trophy} label="Track record" value="Uplifted a million-dollar Microsoft partner" />
            <Row icon={Building2} label="Founder journey" value="Two startups — lessons priced in scars" />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="gt-hairline rounded-3xl overflow-hidden">
            <img
              src="https://images.unsplash.com/flagged/photo-1553642618-de0381320ff3?auto=format&fit=crop&w=1400&q=70"
              alt="Arnab at work"
              className="w-full h-[360px] md:h-[440px] object-cover"
            />
          </div>

          <div className="mt-8 grid md:grid-cols-2 gap-6">
            <div className="gt-hairline rounded-2xl p-6 bg-white/[0.02]">
              <div className="text-xs tracking-[0.3em] text-emerald-400 uppercase mb-2">Vision</div>
              <p className="text-neutral-300 leading-relaxed">
                Influence and teach digital natives with the right dose of Urban English, brand
                building, and the science of sales — so they stand on their own feet, at a global bar.
              </p>
            </div>
            <div className="gt-hairline rounded-2xl p-6 bg-white/[0.02]">
              <div className="text-xs tracking-[0.3em] text-emerald-400 uppercase mb-2">Philosophy</div>
              <p className="text-neutral-300 leading-relaxed">
                We don’t chase attention. We engineer conviction — in the room, on the call, in
                the contract. The 2% tribe closes what the 98% only pitches.
              </p>
            </div>
          </div>

          <div className="mt-6 text-sm text-neutral-500">
            <span className="text-neutral-300">{brand.founder}</span> · {brand.location}
          </div>
        </div>
      </div>
    </section>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-4 p-4 gt-hairline rounded-xl bg-white/[0.02]">
      <div className="w-10 h-10 rounded-lg bg-emerald-400/10 border border-emerald-400/30 flex items-center justify-center">
        <Icon className="w-4 h-4 text-emerald-400" />
      </div>
      <div>
        <div className="text-[11px] tracking-[0.3em] text-neutral-500 uppercase">{label}</div>
        <div className="text-white mt-1">{value}</div>
      </div>
    </div>
  );
}
